import { render } from "./CompactNestedMethod.vue?vue&type=template&id=66efdf6d&lang=pug"
import script from "./CompactNestedMethod.vue?vue&type=script&lang=js"
export * from "./CompactNestedMethod.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__